import { inject, Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class DynamicSnackBarService {

  constructor() { }
  
    #snackBar = inject(MatSnackBar);
    #snackBarHorizontalPosition: MatSnackBarHorizontalPosition = 'center';
    #snackBarVerticalPosition: MatSnackBarVerticalPosition = 'bottom';

    openSnackBar(message = '', 
      horizontalPosition: MatSnackBarHorizontalPosition = this.#snackBarHorizontalPosition, 
      verticalPosition: MatSnackBarVerticalPosition = this.#snackBarVerticalPosition, 
      duration = 15 * 1000) {  
      this.#snackBar.open(message, 'Close', {
        horizontalPosition: horizontalPosition,
        verticalPosition: verticalPosition,
        duration: duration
      });
    }
}
